const localStorage = window.localStorage;

const Storage = {
  /****************
   * AUTH
   ****************/
  auth: {
    // Auth token
    async getAuthToken() {
      return localStorage.getItem('AuthToken');
    },
    async setAuthToken(token) {
      return localStorage.setItem('AuthToken', token);
    },
    async removeAuthToken() {
      return localStorage.removeItem('AuthToken');
    },
  },
  user: {
    async getUserInfo() {
      return localStorage.getItem('UserInfo');
    },
    async setUserInfo(info) {
      return localStorage.setItem('UserInfo', info);
    },
    async removeUserInfo() {
      return localStorage.removeItem('UserInfo');
    },
  },
};

export default Storage;
